<template>
  <div v-if="areNotificationsVisible">
    <menu-notification-item
      v-if="isAccountLimitNotificationVisible"
      :header="translations.freeLimitAmount"
    >
      <span class="f-color-gray">
        {{ translations.toIncrease }}
      </span>
      <bb-link :to="{ name: AccountRouteName.AccountVerification }">
        {{ translations.learnMore }}
      </bb-link>
    </menu-notification-item>
    <menu-notification-item
      v-if="isCurrencyPreferenceNotificationVisible"
      :header="translations.currencyPreferenceHeader"
    >
      <div class="f-color-gray">
        {{ translations.currencyPreferenceDescription }}
        <bb-link :to="{ name: AccountRouteName.Preferences }">
          {{ translations.settingsLinkText }}
        </bb-link>
      </div>
    </menu-notification-item>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useAccountStore } from '@account/store/accountStore'
import { useRootStore } from '@/store/root'
import { AccountRouteName } from '@account/const'
import MenuNotificationItem from './MenuNotificationItem.vue'

export default {
  name: 'menu-notifications',
  components: {
    MenuNotificationItem
  },
  data () {
    return {
      AccountRouteName
    }
  },
  computed: {
    ...mapState(useAccountStore, ['verificationData']),
    ...mapState(useRootStore, ['featureFlags']),
    translations () {
      return {
        freeLimitAmount: this.$pgettext('account_verification', 'Account is limited'),
        toIncrease: this.$pgettext('account_verification', 'To increase your account limit we need to verify you account.'),
        learnMore: this.$pgettext('account_verification', 'Learn more'),
        currencyPreferenceHeader: this.$pgettext('currency_preference', 'Bulgaria is preparing to adopt the Euro.'),
        currencyPreferenceDescription: this.$pgettext('currency_preference', 'You can set up currency viewing preferences in'),
        settingsLinkText: this.$pgettext('currency_preference', 'settings')
      }
    },
    areNotificationsVisible () {
      return this.isAccountLimitNotificationVisible ||
        this.isCurrencyPreferenceNotificationVisible
    },
    isAccountLimitNotificationVisible () {
      return this.featureFlags.enableUnverifiedCustomerAdditionalLimits &&
        !(this.verificationData?.isF2fIdentified ?? true)
    },
    isCurrencyPreferenceNotificationVisible () {
      return !!this.featureFlags.preferenceTab &&
        !!this.featureFlags.enableMulticurrencyBgnEur
    }
  }
}
</script>
